/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import ThemedIcon from '../../common/ThemedIcon';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import CardContainer from '../../common/CardContainer';
import { Text } from '../../common/Text';
import { openFileViewer } from '../../../actions';
import StyledTappable from '../../common/StyledTappable';

import downloadIcon from '../../../images/download.svg';
import { logEvent } from '../../../utils/logEvent';
import medicine from '../../../images/medicine.svg';
import labTest from '../../../images/labtestnew.svg';

const OuterContainer = styled(CardContainer)`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: flex-start;
  margin: 24px 20px 0px 24px;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  box-sizing: border-box;
  border-radius: 12px;
  max-width: 80%;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f3f6;
  padding-top: 16px;
`;

const HeaderText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-left: 16px;
  line-height: 150%;
  color: #0f0b28;
`;

const DownloadContainer = styled(StyledTappable)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  color: #6544c6;
  font-weight: 600;
  min-height: 40px;
  padding: 0 8px;
  margin: -12px 8px -12px 0;
  font-size: 10px;
  line-height: 12px;
`;

const DownloadIcon = styled.img`
  width: 18px;
  height: 18px;
  color: #6544c6;
`;

const BodyContainer = styled.div`
  align-self: stretch;
  display: flex;
  margin-top: 16px;
  flex-direction: column;
  align-items: flex-start;
`;

const MedicineContainer = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 10px;
`;

const MedicineIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const MedicineTextContainer = styled.div`
  display: flex;
  margin-left: 8px;
  flex-direction: column;
  align-items: flex-start;
`;

const MedicineText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: #0f0b28;
`;

const MedicineDosageText = styled(Text)`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: #767787;
`;

const LabTestHeaderText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 15px;
  text-transform: uppercase;
  color: #767787;
  margin: 16px;
`;

const MedicineHeaderTest = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 15px;
  text-transform: uppercase;
  color: #767787;
  margin: 16px 16px 0px 16px;
`;

const LabTestText = styled(Text)`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  margin-left: 8px;
  align-items: center;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const NewPharmacyButton = styled.div`
  background: var(--primary-button);
  border-radius: 12px;
  align-self: stretch;
  width: calc(100%-40px);
  margin: 20px 16px 20px 16px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  padding: 11px 0px 13px 0px;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #ffffff;
`;

const OrderMedicineButton = styled.div`
  background: ${(props) =>
    props.showButtonLoading ? '#f0f3f6' : 'var(--primary-button)'};
  border-radius: 12px;
  align-self: stretch;
  width: 100%;
  margin: 20px 0px 20px 0px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  padding: 11px 0px 13px 0px;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: ${(props) => (props.showButtonLoading ? '#585969' : '#fff')};
`;
const DownloadText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: right;
  margin-left: 4px;
  letter-spacing: 0.25px;
  color: var(--primary-button);
`;

const renderMedicine = (ele, idx) => (
  <MedicineContainer key={idx}>
    <MedicineIcon src={medicine} />
    <MedicineTextContainer>
      <MedicineText>{ele.drugName}</MedicineText>
      <MedicineDosageText>{ele.drugLabel}</MedicineDosageText>
    </MedicineTextContainer>
  </MedicineContainer>
);

const PrescriptionMessage = (props) => {
  const {
    medicines,
    labTests,
    prescriptionLink,
    prescriptionId,
    history,
    openAddressModal,
    showButtonLoading,
    isChatSdk,
    authToken,
  } = props;
  const dispatch = useDispatch();
  return (
    <OuterContainer>
      <HeaderContainer>
        <HeaderText>Your Prescription</HeaderText>
        <DownloadContainer
          onTap={() => {
            // if (window.ReactNativeWebView) {
            //   window.ReactNativeWebView.postMessage(
            //     JSON.stringify({
            //       method: 'openUrl',
            //       link: prescriptionLink,
            //     })
            //   );
            // } else if (!openDocumentInNativeApp(prescriptionLink, authToken)) {
            //   dispatch(
            //     openFileViewer({
            //       contentUrl: prescriptionLink,
            //       title: 'Prescription',
            //       type: 'pdf',
            //     })
            //   );
            //   // document.querySelector(`#image-anchor-${prescriptionId}`).click();
            // }
            dispatch(
              openFileViewer({
                contentUrl: prescriptionLink,
                title: 'Prescription',
                type: 'pdf',
              })
            );
          }}
        >
          <DownloadIcon src={downloadIcon} />
          <a
            href={prescriptionLink}
            target="_blank"
            rel="noopener noreferrer"
            id={`prescription-message-${prescriptionId}`}
            style={{ display: 'none' }}
          />
          <DownloadText>Download</DownloadText>
        </DownloadContainer>
      </HeaderContainer>
      {!isChatSdk && (
        <>
          <div
            style={{
              borderBottom: '1px solid #F0F3F6',
              marginLeft: '16px',
              marginRight: '16px',
              alignSelf: 'stretch',
            }}
          >
            {medicines?.length > 0 && (
              <MedicineHeaderTest>Medicine</MedicineHeaderTest>
            )}

            {medicines?.length > 0 && (
              <BodyContainer>{medicines?.map(renderMedicine)}</BodyContainer>
            )}

            {medicines?.length > 0 && (
              <OrderMedicineButton
                showButtonLoading={showButtonLoading}
                onClick={() => {
                  if (showButtonLoading) return;
                  else openAddressModal('pharmacy');
                }}
              >
                {showButtonLoading ? 'Loading...' : ' Order Medicine'}
              </OrderMedicineButton>
            )}
          </div>
          {labTests?.length > 0 && (
            <LabTestHeaderText showBorderTop={medicines?.length > 0}>
              Lab tests
            </LabTestHeaderText>
          )}
          {labTests?.map((ele) => {
            return (
              <div
                className="flex items-center"
                style={{
                  alignItems: 'flex-start',
                  marginLeft: '16px',
                  marginTop: '12px',
                }}
              >
                <ThemedIcon
                  src={labTest}
                  alt="lab"
                  height={'20px'}
                  width={'20px'}
                />
                <LabTestText>{ele}</LabTestText>
              </div>
            );
          })}

          {labTests?.length > 0 && (
            <div className="w-full border-t mt-16px border-txtsecondary-shades4">
              <NewPharmacyButton onClick={() => openAddressModal('lab')}>
                Book Tests
              </NewPharmacyButton>
            </div>
          )}
        </>
      )}
    </OuterContainer>
  );
};
const mapStateToProps = (state) => ({
  sponsorId: state.user.sponsorId,
  authToken: state.user.authToken,
});
const mapDispatchToProps = (dispatch) => ({
  openFileViewer: (content) => dispatch(openFileViewer(content)),
});

PrescriptionMessage.propTypes = {
  medicines: PropTypes.arrayOf(
    PropTypes.shape({
      drugName: PropTypes.string.isRequired,
      drugLabel: PropTypes.string.isRequired,
    })
  ),
  labTests: PropTypes.arrayOf(PropTypes.string),
  prescriptionLink: PropTypes.string,
  prescriptionId: PropTypes.number,
};

PrescriptionMessage.defaultProps = {
  medicines: [],
  labTests: [],
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrescriptionMessage)
);
